import { useState, useEffect } from 'react'
import css from './sass/createedit.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { handleEnterKey } from '../components/utils'
import { adminSearchFunds } from './auctionsadminutil'

export default function InputFundSearch({ fundNumber, setFundNumber, fundName, setFundName, 
  isReadOnly, fundNumberInput, setFundNumberInput, auctionChanges, auction }) {
    
  const inputValue = (value) => value ?? ''

  const [needsFund, setNeedsFund] = useState(false)
  const [searchResults, setSearchResults] = useState([])
  const [showSearchResults, setShowSearchResults] = useState(false)

  const [isSearching, setIsSearching] = useState(false)

  // Initialize fund values on mount or when auction changes
  useEffect(() => {

    if (auctionChanges !== null) {
      const nameHasLength = auctionChanges?.fundName?.length > 0
      const numberHasLength = auctionChanges?.fundNumber?.length > 0
      const inputHasLength = auctionChanges?.fundNumberInput?.length > 0

      if (nameHasLength) {
        setFundName(auctionChanges.fundName)
        setFundNumberInput(auctionChanges.fundName)
      }
      if (numberHasLength) {
        setFundNumber(auctionChanges.fundNumber)
        setFundNumberInput(auctionChanges.fundNumberInput)
      }
      if ((!nameHasLength && !numberHasLength) && inputHasLength) {
        setFundNumber('')
        setFundName('')
        setFundNumberInput(auctionChanges.fundNumberInput)
      }
    } else {
      setFundName(auction?.FundName)
      setFundNumber(auction?.FundNumber)
      setFundNumberInput(auction?.FundNumber)
    }
  
  }, [auction?.AuctionId])

  // Update needsFund state when fund values change
  useEffect(() => {

    if (fundName === '' || fundNumber === '' || fundName === null || fundNumber === null) setNeedsFund(true)
    else {
      setNeedsFund(false)
      // Don't update fundNumberInput here - it causes issues
      // if (auctionChanges !== null) setFundNumberInput(auctionChanges?.fundNumberInput)
      // else setFundNumberInput(fundNumber)
    }
    
  }, [fundName, fundNumber])

  const searchFunds = async () => {
    setIsSearching(true)
    const query = fundNumberInput.toLowerCase()
    const funds = await adminSearchFunds(query)
    setIsSearching(false)
    setShowSearchResults(true)
    setSearchResults(funds)
  }

  const selectFund = (fund) => {
    setFundName(fund.publicName)
    setFundNumber(fund.lookupId)
    setShowSearchResults(false)
  }

  const removeFund = () => {
    if (isReadOnly) return
    setFundName('')
    setFundNumber('')
    setShowSearchResults(false)
  }

  return (
    <>
      <div className={css['selected-fund-header']}>
      <h5 className={css['sub-header']}>Fund Information</h5>
        {needsFund ? <p className={css['error-text']}>No fund selected.</p>
          : <p className={`${css['red-button']} ${isReadOnly ? css['red-button-disabled'] : ''}`}
           onClick={() => removeFund()}> Remove Fund </p>}

      </div>
        { needsFund && <>
          <p>Please search to select a fund. You can search by fund name or fund number.</p>
      <div className={css["fund-search-input"]}>
        <input id="editAuctionFundNumber" type='text'
          placeholder='e.g. 63090C'
          value={inputValue(fundNumberInput)}
          disabled={isReadOnly || isSearching}
          onKeyDown={(e) => handleEnterKey(e, searchFunds)}
          onChange={(e) => setFundNumberInput(e.target.value)} />
        <button className={`${themeCss['button']} ${themeCss['FilledBlue']}`} disabled={isReadOnly || isSearching}
          onClick={()=>searchFunds()}> SEARCH </button>
        {isSearching && <p className={css['fund-search-searching']}>Searching...</p>}
      </div>
          </>}

      {showSearchResults && <div>
        <div className={css['selected-fund-header']}>
          {searchResults?.length === 0 ? <h5>No results found.</h5> : <h5>{searchResults?.length} result{searchResults?.length === 1 ? '' : 's'} found.</h5>}
        </div>
        {searchResults?.length > 0 && <div className={css['fund-search-results']}>
          {searchResults.map((fund) => {
            return (<div key={fund.lookupId} className={css['fund-search-results-row']}>
              <div>
                <p>{fund.lookupId}</p>
                <p>{fund.publicName}</p>
              </div>
              <button className={`${themeCss['button']} ${themeCss['FilledWhite']}`} onClick={() => selectFund(fund)}> Select </button>
            </div>)
          })}
        </div>}
      </div>}

      {(fundNumber?.length > 0 && fundName?.length > 0) && <>  
        <div className={css['edit-item-input']}>
          <label>Fund Name</label>
          <input id="editAuctionFundName" type='text'
            value={inputValue(fundName)}
            disabled={true} />
        </div>
        <div className={css['edit-item-input']}>
          <label>Fund Number</label>
          <input id="editAuctionFundNumber" type='text'
            value={inputValue(fundNumber)}
            disabled={true} />
        </div>
      </>}
    </>
  )
}
